import React from "react";
import moment from "moment";
import {
  Modal,
  Row,
  Box,
  Botao,
  Alerta,
  TipoAlerta,
  Form,
  CampoTexto,
  Combo,
  TipoBotao,
  Col,
  TamanhoBotao,
} from "@intechprev/componentes-web";
import { RecadastramentoService, PlanoService, FormulariosService } from "../../services";
import { WebRecadParticipanteDadosEntidade, PlanoVinculadoEntidade, DependenteEntidade, SexoEntidade } from "../../entidades";
import { DMN_PLANO } from "../../domains";

interface Props {
  Avancar: () => void;
  Voltar: () => void;
  setListaDependente: any;
  ListaDependente: Array<DependenteEntidade>;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  NumeroPassoAtual: number;
  isEmptyString: any;
}

interface State {
  GrauParentesco: string;
  Nome: string;
  DataNascimento: string;
  Sexo: string;
  Cpf: string;
  NumSeqDep: number;
  ListaDependente: Array<DependenteEntidade>;
  ListaSexo: Array<SexoEntidade>;
  VisibilidadeModal: boolean;
  TituloModal: string;
  TituloBotaoModal: string;
  AcaoModal: any;
  DepAtivo: DependenteEntidade;
  Planos: Array<PlanoVinculadoEntidade>;
}

export class Passo7 extends React.Component<Props, State> {
  private form = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();
  private alertaModal = React.createRef<Alerta>();

  private OpcoesGrauParentesco = [
    {
      Value: "01",
      Name: "CONJUGE",
    },
    {
      Value: "02",
      Name: "COMPANHEIRO(A)",
    },
    {
      Value: "03",
      Name: "FILHO(A)",
    },
    {
      Value: "04",
      Name: "FILHO(A) INVÁLIDO",
    },
    {
      Value: "06",
      Name: "PAI/MÃE",
    },
  ];

  constructor(props: Props) {
    super(props);

    this.state = {
      GrauParentesco: "",
      Nome: "",
      DataNascimento: "",
      Sexo: "",
      Cpf: "",
      NumSeqDep: 0,
      ListaDependente: new Array<DependenteEntidade>(),
      ListaSexo: new Array<SexoEntidade>(),
      VisibilidadeModal: false,
      TituloModal: "",
      TituloBotaoModal: "",
      AcaoModal: null,
      DepAtivo: new DependenteEntidade(),
      Planos: new Array<PlanoVinculadoEntidade>(),
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ListaSexo = await RecadastramentoService.BuscarListaSexo();

      const ListaDependente = this.props.ListaDependente.length > 0 ? this.props.ListaDependente : await RecadastramentoService.BuscarBeneficiarios();

      const Planos = await PlanoService.Buscar();

      this.setState({
        ListaDependente,
        ListaSexo,
        Planos,
      });
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  Voltar = () => {
    this.props.Voltar();
  };

  Proximo = async (): Promise<any> => {
    try {
      await this.alerta.current.limparErros();

      let dependentesSemExcluidos = this.state.ListaDependente.filter((dep) => dep.IND_OPERACAO !== "EXC");

      const semCPF = dependentesSemExcluidos.some((dep) => dep.CPF === null || dep.CPF === undefined || dep.CPF === "");

      if (semCPF) {
        await this.alerta.current.adicionarErro("É obrigatório informar o CPF de todos os dependentes.");
        return false;
      }

      this.props.Avancar();
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  Remover = (dep: DependenteEntidade) => {
    if (window.confirm("Deseja realmente remover o beneficiário selecionado? A remoção será efetivada apenas após análise da PREVIRB.")) {
      dep.IND_OPERACAO = "EXC";
      dep.CD_PLANO = this.state.Planos[0].CD_PLANO;
      const ListaAtualizada = this.state.ListaDependente.filter((item) => item !== dep);
      this.setState({
        ListaDependente: [...ListaAtualizada, dep],
      });
      this.props.setListaDependente([...ListaAtualizada, dep]);
    }
  };

  Incluir = async () => {
    try {
      await this.alertaModal.current.limparErros();
      await this.form.current.validar();

      if (this.form.current.isValido()) {
        await RecadastramentoService.ValidarCpf(this.state.Cpf);

        const gp: any = this.OpcoesGrauParentesco.filter((item) => item.Value === this.state.GrauParentesco);
        let novoDep = new DependenteEntidade();
        novoDep.DS_GRAU_PARENTESCO = gp[0].Name;
        novoDep.CD_GRAU_PARENTESCO = this.state.GrauParentesco;
        novoDep.NOME_DEP = this.state.Nome;
        novoDep.DT_NASC_DEP = moment(this.state.DataNascimento, "DD/MM/YYYY").toDate();
        novoDep.SEXO_DEP = this.state.Sexo;
        novoDep.CPF = this.state.Cpf;
        novoDep.CD_FUNDACAO = this.props.DadosOriginais.CD_FUNDACAO;
        novoDep.CD_PLANO = this.state.Planos[0].CD_PLANO;
        novoDep.NUM_INSCRICAO = this.props.DadosOriginais.NUM_INSCRICAO;
        novoDep.NUM_SEQ_DEP = 0;
        novoDep.IND_OPERACAO = "INC";
        const ListaAtualizada = [...this.state.ListaDependente, novoDep];
        this.setState({
          ListaDependente: ListaAtualizada,
          VisibilidadeModal: false,

          GrauParentesco: "",
          Nome: "",
          DataNascimento: "",
          Sexo: "",
          Cpf: "",
          NumSeqDep: 0,
        });
        this.props.setListaDependente(ListaAtualizada);
      }
    } catch (e) {
      const err: any = e;
      await this.alertaModal.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  Editar = async () => {
    try {
      await this.alertaModal.current.limparErros();
      await this.form.current.validar();

      if (this.form.current.isValido()) {
        await RecadastramentoService.ValidarCpf(this.state.Cpf);

        const gp: any = this.OpcoesGrauParentesco.filter((item) => item.Value === this.state.GrauParentesco);
        let novoDep = this.state.DepAtivo;
        novoDep.DS_GRAU_PARENTESCO = gp[0].Name;
        novoDep.CD_GRAU_PARENTESCO = this.state.GrauParentesco;
        novoDep.NOME_DEP = this.state.Nome;
        novoDep.DT_NASC_DEP = moment(this.state.DataNascimento, "DD/MM/YYYY").toDate();
        novoDep.SEXO_DEP = this.state.Sexo;
        novoDep.CPF = this.state.Cpf;
        novoDep.NUM_SEQ_DEP = this.state.NumSeqDep;
        novoDep.IND_OPERACAO = "ALT";
        novoDep.CD_PLANO = this.state.Planos[0].CD_PLANO;

        const ListaAtualizada = this.state.ListaDependente.filter((item) => item !== novoDep);
        this.setState({
          ListaDependente: [...ListaAtualizada, novoDep],
          VisibilidadeModal: false,

          GrauParentesco: "",
          Nome: "",
          DataNascimento: "",
          Sexo: "",
          Cpf: "",
          NumSeqDep: 0,
        });
        this.props.setListaDependente([...ListaAtualizada, novoDep]);
      }
    } catch (e) {
      const err: any = e;
      await this.alertaModal.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  ModalIncluir = async () => {
    if (this.state.Planos.some(x => x.CD_PLANO === DMN_PLANO.PREVIDENCIAL_B)) {
      await this.GerarRelatorioInclusaoExclusaoPensaoPorMorte();
    }
    else {
      this.setState({
        TituloModal: "Inclusão Beneficiário de Pensão",
        TituloBotaoModal: "Incluir",
        VisibilidadeModal: true,
        AcaoModal: this.Incluir,
      });
    }
  };

  GerarRelatorioInclusaoExclusaoPensaoPorMorte = async () => {
    await this.alertaModal.current!.limparErros();
    try {
      const relatorio = await FormulariosService.GetRelatorioInclusaoExclusaoPensaoPorMorte(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "inclusao_exclusao_pensao_por_morte.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'inclusao_exclusao_pensao_por_morte.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      const err: any = e;
      if (err.response) {
        await this.alertaModal.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alertaModal.current!.adicionarErro(err);
      console.error(err);
    }
  }

  ModalEditar = (dep: DependenteEntidade) => {
    this.setState({
      TituloModal: "Edição Beneficiário de Pensão",
      TituloBotaoModal: "Gravar",
      VisibilidadeModal: true,
      AcaoModal: this.Editar,
      DepAtivo: dep,

      GrauParentesco: dep.CD_GRAU_PARENTESCO,
      Nome: dep.NOME_DEP,
      DataNascimento: moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY"),
      Sexo: dep.SEXO_DEP,
      Cpf: dep.CPF,
      NumSeqDep: dep.NUM_SEQ_DEP,
    });
  };

  FecharModal = () => {
    this.setState({
      VisibilidadeModal: false,
    });
  };

  renderDependentes = () => {
    if (this.state.ListaDependente.length > 0) {
      const deps = this.state.ListaDependente.map((dep: DependenteEntidade, index: number) => {
        const cor = dep.IND_OPERACAO === "EXC" ? "text-danger" : index % 2 === 0 ? "table-active" : "";
        return (
          <tr className={cor} key={index}>
            <td>{dep.DS_GRAU_PARENTESCO}</td>
            <td>{dep.NOME_DEP}</td>
            <td>{moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY")}</td>
            <td>{dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
            <td>{dep.CPF}</td>
            <td>
              <Botao titulo={"Editar"} tamanho={TamanhoBotao.mini} tipo={TipoBotao.primary} onClick={() => this.ModalEditar(dep)} />
            </td>
            <td>
              <Botao titulo={"Excluir"} tamanho={TamanhoBotao.mini} tipo={TipoBotao.danger} onClick={() => this.Remover(dep)} />
            </td>
          </tr>
        );
      });

      return (
        <table className={"table table-responsive"}>
          <thead>
            <tr>
              <th style={{ width: "150" }}>Grau de Parentesco</th>
              <th style={{ width: "250" }}>Nome</th>
              <th style={{ width: "150" }}>Data de Nascimento</th>
              <th>Sexo</th>
              <th>CPF</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>{deps}</tbody>
        </table>
      );
    }
    return <Alerta tipo={TipoAlerta.info} mensagem={"Nenhum beneficiário cadastrado."} />;
  };

  renderModalBody = () => {
    return (
      <Form ref={this.form}>
        <Combo
          contexto={this}
          titulo={"Grau de Parentesco"}
          nome={"GrauParentesco"}
          valor={this.state.GrauParentesco}
          opcoes={this.OpcoesGrauParentesco}
          nomeMembro={"Name"}
          valorMembro={"Value"}
          textoVazio={"Escolha um Grau de Parentesco"}
          obrigatorio
        />

        <CampoTexto contexto={this} nome={"Nome"} titulo={"Nome do Dependente"} obrigatorio max={40} valor={this.state.Nome} />

        <CampoTexto
          contexto={this}
          nome={"DataNascimento"}
          titulo={"Data de Nascimento"}
          obrigatorio
          mascara={"99/99/9999"}
          valor={this.state.DataNascimento}
        />

        <Combo
          contexto={this}
          titulo={"Sexo"}
          nome={"Sexo"}
          valor={this.state.Sexo}
          opcoes={this.state.ListaSexo}
          nomeMembro={"DS_SEXO"}
          valorMembro={"CD_SEXO"}
          textoVazio={"Escolha um Sexo"}
          obrigatorio
        />

        <CampoTexto contexto={this} nome={"Cpf"} titulo={"CPF"} obrigatorio mascara={"999.999.999-99"} valor={this.state.Cpf} />

        <Alerta tipo={TipoAlerta.danger} padraoFormulario ref={this.alertaModal} />
      </Form>
    );
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Beneficiários para Fins de Pensão`}>
        <Box>
          <ol>
            {"A legislação em vigor enumera os dependentes de segurado do INSS em ordem de prioridade conforme as 3 classes abaixo:"}
            <li>
              {"Classe 1"}
              <br />
              {"Cônjuge ou companheira (o), inclusive homoafetivo;"}
              <br />
              {"Filho não emancipado ou equiparado, de qualquer condição, menor de 21 anos de idade; ou"}
              <br />
              {"Filho com qualquer idade, com invalidez ou deficiência intelectual ou mental que o torne absoluta ou relativamente incapaz, assim declarado pela justiça."}
            </li>
            <li>
              {"Classe 2"}
              <br />
              {"Pais"}
            </li>
            <li>
              {"Classe 3"}
              <br />
              {"Irmão não emancipado, de qualquer condição, menor de 21 anos; ou,"}
              <br />
              {"Irmão de qualquer idade, com invalidez ou deficiência intelectual ou mental que o torne absoluta ou relativamente incapaz, assim declarado pela justiça."}
            </li>
          </ol>
          <ul>
            {"Importante!"}
            <li>
              {"Para concessão do benefício será observada a ordem de prioridade das classes. A classe anterior, exclui a seguinte, ou seja, se por exemplo a pessoa falecida tinha cônjuge, automaticamente os pais e o irmão estão excluídos."}
            </li>
          </ul>
          <span>{"Fonte: https://www.gov.br/pt-br/servicos/solicitar-pensao-por-morte-urbana"}</span>
        </Box>

        {this.renderDependentes()}

        <Alerta tipo={TipoAlerta.danger} ref={this.alerta} />

        {this.state.Planos && this.state.Planos[0] && this.state.Planos.some(x => x.CD_PLANO === DMN_PLANO.PREVIDENCIAL_B) && <Alerta tipo={TipoAlerta.info} mensagem="Caso seja necessária a inclusão de potencial dependente para o benefício de Pensão por Morte, por favor, preencher o formulário, imprimir e assiná-lo presencialmente na sede da Fundação. Diante da impossibilidade do comparecimento, a assinatura no documento deve ter firma reconhecida e enviada pelos Correios." />}

        <Row>
          <Col>
            <Botao tipo={TipoBotao.success} titulo={"Incluir Beneficiário"} usaLoading onClick={this.ModalIncluir} />
          </Col>
        </Row>

        <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

        <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />

        <Modal
          onConfirm={this.state.AcaoModal}
          onClose={this.FecharModal}
          titulo={this.state.TituloModal}
          tituloBotaoFechar={this.state.TituloBotaoModal}
          visivel={this.state.VisibilidadeModal}
        >
          {this.renderModalBody()}
        </Modal>
      </Box>
    );
  }
}
